import React from 'react';

// Big uppercase English headline used across the site ("OUR / PRODUCTS",
// "NEWS", "CONTACT / US"), each word-group on its own line with chosen lines
// in brand blue, plus an optional small localized caption underneath.
//   lines – array of strings, one per line
//   blue  – indexes of lines to colour blue (defaults to the last line)
//   light – white text for use on charcoal bands
export default function EnTitle({ lines, blue, sub, light = false, as: Tag = 'h2', className = 'text-5xl sm:text-6xl lg:text-7xl', subClassName = '' }) {
  const blueLines = blue ?? [lines.length - 1];
  return (
    <div>
      <Tag className={`en-title ${light ? 'text-white' : ''} ${className}`}>
        {lines.map((line, i) => (
          <span key={i} className={`block ${blueLines.includes(i) ? 'text-primary' : ''}`}>{line}</span>
        ))}
      </Tag>
      {sub && <p className={`mt-3 font-bold text-sm sm:text-base ${light ? 'text-white' : 'text-charcoal'} ${subClassName}`}>{sub}</p>}
    </div>
  );
}

// Splits "OUR PRODUCTS" into ["OUR", "PRODUCTS"]: everything but the last
// word on line one, the last word (shown blue) on line two.
export function splitEn(text) {
  const words = String(text || '').trim().split(/\s+/).filter(Boolean);
  if (words.length < 2) return words;
  return [words.slice(0, -1).join(' '), words[words.length - 1]];
}
